import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import { getOrganizationAutosuggestJF } from 'app/services/partner/autosuggest';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

const OrganizationAutosuggestJF = autosuggestFactory({
   apiPromise: getOrganizationAutosuggestJF,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndNameAsLabel,
   defaultPlaceholder: 'Search Organization...',
});

export default withAutosuggestWrapper(withInputErrorMessage(OrganizationAutosuggestJF));
